// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.title {
  position: absolute;
  top: 12px;
  left: 50%;
  height: 5%;
  width: 40%;
  transform: translateX(-50%);
  padding: 5px 10px;
  border: solid gray;
  border-radius: 1vw;
  font-weight: bold;
  color: #FFFFFF;
  background-color: rgba(35, 68, 91, 0.9);
  /* background-color: #23445B; */
  z-index: 1000;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaflet-container {
  width: 100vw;
  height: 100vh;
}


.ant-modal {
  top: 0;
  width: 300px;
  padding: 10px;
}

.ant-drawer-header, .ant-drawer-body {
  color: whitesmoke;
  /* background-color: rgba(35, 68, 91, 0.9); */
  background-color: #23445B;
  border-left: solid gray;
}

.ant-drawer-close {
  color: whitesmoke !important;
}


.leaflet-popup-content-wrapper .leaflet-popup-content {
  overflow: hidden !important;
  border-radius: 12px;
  margin: 0 !important;
  padding: 0 !important;
}

.ant-carousel .slick-prev,
.ant-carousel .slick-prev:hover {
  left: 10px;
  z-index: 2;
  color: white;
  font-size: 20px;
  height: 30px;
}

.ant-carousel .slick-next,
.ant-carousel .slick-next:hover {
  right: 10px;
  z-index: 2;
  color: white;
  font-size: 20px;
  height: 30px;
}

.fullScreenDrawer {
  @media (max-width: 767px) {
    .ant-drawer-content {
      width: 100% !important;
    }
  }
}

.custom-svg-icon img {
  filter: drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.6)); /* Shadow effect */
}

.location-marker, .blinking-marker {
  border: solid white;
  position: relative;
  background-color: #3ECBFF; /* Bright Cyan */
  border-radius: 50%;
  filter: drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.8));
  width: 40px;  /* Increased size */
  height: 40px; /* Increased size */
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.blinking-marker {
  animation: blink 1s infinite;
}

.inner-circle {
  background-color: white;
  border-radius: 50%;
  width: 20px; /* Half size of outer circle */
  height: 20px; /* Half size of outer circle */
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.form {
  /* position: absolute; */
  display: flex;
  flex-direction: column;
  width: 100%; /* Make input fields take up the full container width */
  margin: 0.5em;
  padding: 10px;
  }

.report-btn, .reset-btn, .menu-btn {
  position: absolute;
  bottom: 10vh;
  right: 1px;
  transform: translateX(-50%);
  z-index: 1000;
  width: 50px;
  height: 50px;
  background-color: #23445B;
  color: white;
  /* border: solid white; */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 10px 20px; */
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.8);
  transition: background-color 0.3s;
}

.report-btn:hover {
  background-color: #548fb7;
}

.reset-btn {
  /* background-color: #3ECBFF; */
  background-color: darkgrey;
}

.reset-btn:hover {
  background-color: grey;
}

.menu-btn {
  position: absolute;
  top: 11px;
  border-radius: 10%;
  width: 30px;
  height: 30px;
  margin: 0;
  right: 110px;
  background-color: #FFFFFF;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  width: 100vw; /* Full viewport width */
  background-color: #f0f0f0; /* Optional: background color */
}

.card-container {
  max-width: 400px; /* Adjust the width as necessary */
  margin: auto;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE;MACE,sBAAsB;IACxB;EACF;AACF;;AAEA;EACE,mDAAmD,EAAE,kBAAkB;AACzE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,mDAAmD;EACnD,WAAW,GAAG,mBAAmB;EACjC,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW,EAAE,8BAA8B;EAC3C,YAAY,EAAE,8BAA8B;EAC5C,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,uDAAuD;EACpE,aAAa;EACb,aAAa;EACb;;AAEF;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,yBAAyB;EACxC,YAAY,EAAE,wBAAwB;EACtC,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,gBAAgB,EAAE,kCAAkC;EACpD,YAAY;EACZ,aAAa;AACf","sourcesContent":[".App {\n  text-align: center;\n}\n\n.title {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  height: 5%;\n  width: 40%;\n  transform: translateX(-50%);\n  padding: 5px 10px;\n  border: solid gray;\n  border-radius: 1vw;\n  font-weight: bold;\n  color: #FFFFFF;\n  background-color: rgba(35, 68, 91, 0.9);\n  /* background-color: #23445B; */\n  z-index: 1000;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.leaflet-container {\n  width: 100vw;\n  height: 100vh;\n}\n\n\n.ant-modal {\n  top: 0;\n  width: 300px;\n  padding: 10px;\n}\n\n.ant-drawer-header, .ant-drawer-body {\n  color: whitesmoke;\n  /* background-color: rgba(35, 68, 91, 0.9); */\n  background-color: #23445B;\n  border-left: solid gray;\n}\n\n.ant-drawer-close {\n  color: whitesmoke !important;\n}\n\n\n.leaflet-popup-content-wrapper .leaflet-popup-content {\n  overflow: hidden !important;\n  border-radius: 12px;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.ant-carousel .slick-prev,\n.ant-carousel .slick-prev:hover {\n  left: 10px;\n  z-index: 2;\n  color: white;\n  font-size: 20px;\n  height: 30px;\n}\n\n.ant-carousel .slick-next,\n.ant-carousel .slick-next:hover {\n  right: 10px;\n  z-index: 2;\n  color: white;\n  font-size: 20px;\n  height: 30px;\n}\n\n.fullScreenDrawer {\n  @media (max-width: 767px) {\n    .ant-drawer-content {\n      width: 100% !important;\n    }\n  }\n}\n\n.custom-svg-icon img {\n  filter: drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.6)); /* Shadow effect */\n}\n\n.location-marker, .blinking-marker {\n  border: solid white;\n  position: relative;\n  background-color: #3ECBFF; /* Bright Cyan */\n  border-radius: 50%;\n  filter: drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.8));\n  width: 40px;  /* Increased size */\n  height: 40px; /* Increased size */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes blink {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n.blinking-marker {\n  animation: blink 1s infinite;\n}\n\n.inner-circle {\n  background-color: white;\n  border-radius: 50%;\n  width: 20px; /* Half size of outer circle */\n  height: 20px; /* Half size of outer circle */\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.5);\n  z-index: 1;\n}\n\n.form {\n  /* position: absolute; */\n  display: flex;\n  flex-direction: column;\n  width: 100%; /* Make input fields take up the full container width */\n  margin: 0.5em;\n  padding: 10px;\n  }\n\n.report-btn, .reset-btn, .menu-btn {\n  position: absolute;\n  bottom: 10vh;\n  right: 1px;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: 50px;\n  height: 50px;\n  background-color: #23445B;\n  color: white;\n  /* border: solid white; */\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* padding: 10px 20px; */\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.8);\n  transition: background-color 0.3s;\n}\n\n.report-btn:hover {\n  background-color: #548fb7;\n}\n\n.reset-btn {\n  /* background-color: #3ECBFF; */\n  background-color: darkgrey;\n}\n\n.reset-btn:hover {\n  background-color: grey;\n}\n\n.menu-btn {\n  position: absolute;\n  top: 11px;\n  border-radius: 10%;\n  width: 30px;\n  height: 30px;\n  margin: 0;\n  right: 110px;\n  background-color: #FFFFFF;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full viewport height */\n  width: 100vw; /* Full viewport width */\n  background-color: #f0f0f0; /* Optional: background color */\n}\n\n.card-container {\n  max-width: 400px; /* Adjust the width as necessary */\n  margin: auto;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
